import React, { ChangeEvent, useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Input,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import galleryIcon from "./../../../../../assets/icons/gallery.png";
import TextAreaComponents from "./../../../../components/TextAreaComponents/TextAreaComponents.tsx";
import jwt_decode from "jwt-decode";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import upload from "./../../../../../assets/icons/cloud-computing.png";
import pending from "./../../../../../assets/icons/pending.png";
import checked from "./../../../../../assets/icons/checked.png";
import LoadingView from "../../../../components/LoadingView/LoadingView.js";

function AddBankDetails(props) {
  const [accountHolderName, setAccountHolderName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [sortCode, setSortCode] = useState("");
  const [iBAN, setIBAN] = useState("");
  const [selectedImages, setSelectedImages] = useState<string[]>([]);
  const [imageFiles, setImageFiles] = useState<File[]>([]);
  const [imageErr, setImageErr] = useState(false);
  const apiAddress = process.env.REACT_APP_SECRET;
  const [userId, setUserId] = useState("");
  const [restaurantId, setRestaurantId] = useState("");
  const Restauranttoken = JSON.parse(localStorage.getItem("restaurant"));
  const [selectedRestaurantDatas, setSelectedRestaurantDatas] = useState([]);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  const [value, setValue] = useState("1");
  const [CompanyBankStatementFiles, setCompanyBankStatementFiles] = useState(
    []
  );
  const [loadingModal, SetloadingModal] = React.useState(false);

  const [tableData, setTableData] = useState({
    Id: "12233445",
    KycCompanyDetailsId: "",
    Name: "Company Bank Statement",
    Description:
      "Bank statement of the corporate bank account (dated within the last 3 months)",
    File: [],
    Comment: "comment",
  });

  useEffect(() => {
    const token = localStorage.getItem("gotasteadmintoken");
    if (token) {
      try {
        const decoded = jwt_decode(token);
        setUserId(decoded.UserId);
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
    loadRestaurantName();
  }, []);

  const handleClose = () => {
    props.onHandleAddItem(false);
    // resetForm();
  };

  //   const resetForm = () => {
  //     setCategoryName("");
  //     setSelectedImages([]);
  //     setImageFiles([]);
  //     setImageErr(false);
  //   };

  let submitableOBJ = {
    id: "string",
    restaurantId: "string",
    accountHolderName: "string",
    accountNumber: "string",
    sortCode: "string",
    iban: "string",
    isApproveByAdmin: "f07294b7-c94d-4d5e-a064-b1282d5b543b",
    isActive: true,
    createdBy: "string",
    creationDate: new Date().toISOString(),
    modifierId: "string",
    modificationDate: new Date().toISOString(),
    document: {
      id: "string",
      restaurantBankDetailId: "string",
      name: "string",
      description: "string",
      fileUrls: [],
    },
  };

  const handleSubmit = async () => {
    // if (props?.isSubmitting) return;
    // props?.setIsSubmitting(true);

    let valid = true;

    if (
      accountHolderName == "" ||
      accountHolderName == undefined ||
      accountHolderName == null
    ) {
      valid = false;
      toast.error("Account Holder Name is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (
      accountNumber == "" ||
      accountNumber == undefined ||
      accountNumber == null
    ) {
      valid = false;
      toast.error("Account Number is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (sortCode == "" || sortCode == undefined || sortCode == null) {
      valid = false;
      toast.error("Sort Code is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (iBAN == "" || iBAN == undefined || iBAN == null) {
      valid = false;
      // toast.error("IBAN is required", {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "colored",
      // });
      setIBAN("N/A");
    }
    if (tableData.File.length == 0) {
      valid = false;
      toast.error("Company bank statement is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (valid) {
      try {
        SetloadingModal(true);
        const id = crypto.randomUUID();
        const documentID = crypto.randomUUID();
        submitableOBJ.id = id;
        submitableOBJ.accountHolderName = accountHolderName;
        submitableOBJ.accountNumber = accountNumber;
        submitableOBJ.sortCode = sortCode;
        submitableOBJ.iban = iBAN;
        submitableOBJ.createdBy = userId;
        submitableOBJ.modifierId = userId;
        submitableOBJ.restaurantId = selectedRestaurantDatas.id;
        submitableOBJ.document.id = documentID;
        submitableOBJ.document.restaurantBankDetailId = id;

        await fileupload(documentID);

        axios({
          method: "post",
          url: apiAddress + "/api/RestaurantBankDetails",
          data: submitableOBJ,
        }).then((response) => {
          console.log(response);

          toast.success("Successfully Saved", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          props?.setIsSubmitting(false);
          SetloadingModal(false);
          handleClose();
        });
      } catch (error) {
        console.error("Error adding category:", error);
        toast.error("Failed to add category", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        SetloadingModal(false);
      }
    }
  };

  const closeLoadingModal = () => {
    SetloadingModal(false);
  };
  const fileupload = async (id) => {
    console.log(id);
    var data = [];

    const formData = new FormData();
    console.log(tableData.File.length);

    tableData.File.forEach((file) => {
      formData.append("file", file);
    });
    await axios({
      method: "post",
      url: apiAddress + "/api/FileUpload/addMultiplefile",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    })
      .then((response) => {
        response.data.map((dt) => {
          let fileUrls = {
            id: crypto.randomUUID(),
            restaurantBankDetailDocumentId: id,
            documentUrl: dt,
          };
          submitableOBJ.document.fileUrls.push(fileUrls);
        });
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });

    console.log(tableData);
    return tableData;
  };

  const [restaurantDatas, setRestaurantDatas] = React.useState([]);

  const token = localStorage.getItem("gotasteadmintoken");

  const loadRestaurantName = () => {
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        setUserId(decodedData.UserId);

        // setTokenData(decodedData)
      } catch (error) {}
    }

    axios
      // .get(apiAddress + "/api/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=" + decodedData.UserId+"&restaurantId="+Restauranttoken.id)
      .get(
        apiAddress +
          `/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=${decodedData.UserId}&restaurantId=${Restauranttoken.id}`
      )
      .then((response) => {
        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.restaurantId,
            title: dt.restaurantName,
          };
          list.push(obj);
        });
        setRestaurantDatas(list);
      });
  };

  const [resturentId, setResturentId] = useState("");
  useEffect(() => {
    const foundItem = restaurantDatas.find((item) => item.id === resturentId);
    setSelectedRestaurant(foundItem);
  }, [restaurantDatas]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const isFileSizeValid = (file, maxSizeInBytes) => {
    if (file && file.size <= maxSizeInBytes) {
      return file;
    }
  };

  const handleCompanyBankStatementFileChange = (event) => {
    var valid = true;
    const files = event.target.files[0];
    const maxSizeInBytes = 50 * 1024 * 1024;

    if (isFileSizeValid(files, maxSizeInBytes)) {
      tableData.File.push(files);
      setCompanyBankStatementFiles([
        ...CompanyBankStatementFiles,
        ...event.target.files,
      ]);
    } else {
      // alert("File size should be less than or equal to 50 MB.");
      valid = false;
      toast.error("File size should be less than or equal to 50 MB", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  return (
    <div>
      <LoadingView open={loadingModal} close={closeLoadingModal} />
      <Dialog
        fullWidth={true}
        open={props.open}
        onClose={handleClose}
        maxWidth={"lg"}
      >
        <ToastContainer />
        <DialogTitle>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Add New Bank Details</Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ width: "100%", typography: "body1" }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <Tab label="Details" value="1" />
                  <Tab label="Documents" value="2" />
                </TabList>
              </Box>
              <TabPanel value="1" sx={{ padding: "10px" }}>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <div
                      className="d-flex"
                      style={{ paddingTop: "1rem", gap: "10px" }}
                    >
                      <Typography style={{ paddingTop: "1rem" }}>
                        Restaurant
                      </Typography>
                    </div>
                  </Grid>
                  <Grid item xs={10}>
                    <Autocomplete
                      defaultValue={selectedRestaurant}
                      id="restaurant-dropdown"
                      options={restaurantDatas}
                      onChange={(event, newInputValue, reason, detail) => {
                        setSelectedRestaurantDatas(newInputValue);
                      }}
                      className="my-3"
                      getOptionLabel={(option) => option.title}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Restaurant"
                        />
                      )}
                    />
                  </Grid>
                </Grid>

                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Account Holder Name
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextAreaComponents
                      label={"Account Holder Name"}
                      value={setAccountHolderName}
                      val={accountHolderName}
                    ></TextAreaComponents>
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Account Number
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextAreaComponents
                      label={"Account Number"}
                      value={setAccountNumber}
                      val={accountNumber}
                    ></TextAreaComponents>
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Sort Code
                    </Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextAreaComponents
                      label={"Sort Code"}
                      value={setSortCode}
                      val={sortCode}
                    ></TextAreaComponents>
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>IBAN</Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <TextAreaComponents
                      label={"IBAN"}
                      value={setIBAN}
                      val={iBAN}
                    ></TextAreaComponents>
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value="2" sx={{ padding: "10px" }}>
                <tr>
                  <td style={{ width: "30%" }}>
                    <h6> Company Bank Statement*</h6>
                    <p className="tableDescription">
                      Bank statement of the corporate bank account (dated within
                      the last 3 months)
                    </p>
                  </td>
                  <td style={{ width: "30%" }}>
                    {tableData.File.length != 0 ? (
                      <div className="d-flex">
                        <img
                          src={checked}
                          alt=""
                          style={{ width: "1.5rem", height: "1.5rem" }}
                        />
                        <p style={{ color: "green", marginLeft: "2px" }}>
                          {" "}
                          Done
                        </p>
                      </div>
                    ) : (
                      <div className="d-flex">
                        <img
                          src={pending}
                          alt=""
                          style={{ width: "1.5rem", height: "1.5rem" }}
                        />
                        <p style={{ color: "#cc9840", marginLeft: "2px" }}>
                          {" "}
                          Not uploaded
                        </p>
                      </div>
                    )}
                  </td>
                  <td>
                    <div className="pt-3">
                      <Input
                        type="file"
                        onChange={handleCompanyBankStatementFileChange}
                        style={{ display: "none" }}
                        id="CompanyBankStatement-file-uploader"
                      />

                      <label
                        htmlFor="CompanyBankStatement-file-uploader"
                        className="uploadText"
                      >
                        Upload
                        <img
                          src={upload}
                          alt="upload"
                          style={{
                            width: "1.5rem",
                            height: "1.5rem",
                            marginLeft: "2px",
                          }}
                        />
                      </label>

                      {tableData.File.length > 0 && (
                        <div>
                          <ul className="dotted-border-forfiles d-flex flex-column">
                            {tableData.File.map((file, index) => (
                              <li key={index}>{file.name}</li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              </TabPanel>
            </TabContext>
          </Box>
        </DialogContent>
        <DialogActions>
          {value === "1" ? (
            <>
              <Button
                onClick={() => {
                  setValue("2");
                }}
                color="primary"
              >
                Next
              </Button>
            </>
          ) : (
            <>
              <Button onClick={handleSubmit} color="primary">
                Add
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AddBankDetails;
